import { Link } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { blogPosts } from '@/data/blogPosts';
import { Calendar, Clock, Tag } from 'lucide-react';

const BlogPage = () => {
  return (
    <div>
      <Navbar />

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="mb-12 text-center">
          <p className="text-sm uppercase tracking-[0.2em] mb-3 font-mono text-accent">Amjed Tours Blog</p>
          <h1 className="text-5xl sm:text-6xl font-bold mb-4" style={{ fontFamily: 'Cabinet Grotesk' }} data-testid="blog-page-title">
            Travel Guides & Tips
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Expert advice on car rentals, road trips, and exploring Pakistan
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="car-card rounded-lg overflow-hidden bg-white group"
              data-testid={`blog-post-${index}`}
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-muted-foreground mb-3">
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {post.readTime}</span>
                </div>
                <h2 className="text-xl font-bold mb-3 group-hover:text-accent transition-colors">{post.title}</h2>
                <p className="text-muted-foreground text-sm line-clamp-3 mb-4">{post.excerpt}</p>
                <div className="flex flex-wrap gap-2">
                  {post.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="text-xs bg-muted px-2 py-1 rounded-full flex items-center gap-1">
                      <Tag className="w-3 h-3" /> {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BlogPage;
